module.exports = __webpack_public_path__ + "img/live.ca343dfc.svg";